import React from 'react';
import PropTypes from 'prop-types';
import recordEvent from 'platform/monitoring/record-event';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { FormNavButtonContinue } from 'platform/forms-system/src/js/components/FormNavButtons';

import content from '../locales/en/content.json';
import EligibilitySummary from '../components/FormDescriptions/EligibilitySummary';

const pageTitle = titleUI(content['eligibility--summary-title'])['ui:title'];

export const NAV_CONTINUE_EVENT = {
  event: 'nav-continue-application',
  form: '10-10d-extended',
  location: 'eligibility-summary',
};

const EligibilitySummaryPage = ({ data = {}, goForward }) => {
  const handleContinue = () => {
    recordEvent(NAV_CONTINUE_EVENT);
    goForward({ formData: data });
  };

  return (
    <form>
      {pageTitle}
      <EligibilitySummary formData={data} />
      <FormNavButtonContinue goForward={handleContinue} />
    </form>
  );
};

EligibilitySummaryPage.propTypes = {
  goForward: PropTypes.func.isRequired,
  data: PropTypes.shape({
    'view:tricareEnrollment': PropTypes.bool,
    'view:sponsorIsDisabled': PropTypes.bool,
  }),
};

export default EligibilitySummaryPage;
